import { render, staticRenderFns } from "./ListaServico.vue?vue&type=template&id=205cceb6&scoped=true"
import script from "./ListaServico.vue?vue&type=script&lang=js"
export * from "./ListaServico.vue?vue&type=script&lang=js"
import style0 from "./ListaServico.vue?vue&type=style&index=0&id=205cceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cceb6",
  null
  
)

export default component.exports